import React from 'react';
import './Base.module.scss';

// FIXME: This is a problem. Move away from global styles and make sure that all components got the necessary styles

const Base: React.FC = ({ children }): JSX.Element => <>{children}</>;

export default Base;
